// extracted by mini-css-extract-plugin
module.exports = {"material":"SelectCollectionMaterialCard_material__1F7bg","dot":"SelectCollectionMaterialCard_dot__dQ9g_","selected":"SelectCollectionMaterialCard_selected__3qGXp"};